// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"3285":"css/admin-app.6671","7182":"css/app.6671"}[chunkId] + ".css";
};